const koKR = {
  'action.adjust': '설정 조정',
  'action.applyCrop': '자르고 재생성',
  'action.applyRecommended': '권장 크기 적용',
  'action.applySize': '크기 적용',
  'action.cancel': '취소',
  'action.cancelConversion': '변환 취소',
  'action.chooseImage': '이미지 선택',
  'action.clearDraft': '복구 데이터 삭제',
  'action.close': '닫기',
  'action.contribute': '기여하기',
  'action.copyLink': '링크 복사',
  'action.cropRegion': '영역 자르기',
  'action.downloadOffline': '오프라인 버전 다운로드',
  'action.exportBuildSheet': '제작용 도안 내보내기',
  'action.exportCsv': 'CSV 내보내기',
  'action.exportPattern': '도안 내보내기',
  'action.exportPng': '색상 번호 포함 도안 PNG 내보내기',
  'action.exportShareCard': '공유 카드 내보내기',
  'action.loadProject': '프로젝트 열기',
  'action.markColorDone': '이 색상 완료 표시',
  'action.markColorUndone': '미완료로 변경',
  'action.ok': '확인',
  'action.print': '인쇄 / 페이지 나누기',
  'action.regenerate': '현재 설정으로 재생성',
  'action.reportIssue': '문제 보고',
  'action.resetCrop': '원본 전체로 초기화',
  'action.resetMaking': '진행 상황 초기화',
  'action.restoreDraft': '미완성 도안 복원',
  'action.restoreFullImage': '원본 전체 영역 복원',
  'action.saveProject': '편집 가능한 프로젝트 저장 (원본 이미지 미포함)',
  'action.share': '공유',
  'action.showAllColors': '전체 표시',
  'action.star': 'GitHub에서 스타 주기',
  'action.startMaking': '제작 시작',
  'action.trySample': '샘플 체험하기',
  'advanced.autoConfigured': '원클릭 모드로 자동 설정됨',
  'advanced.title': '고급 설정',
  'advice.expressiveness': '현재 표현 가능 용량',
  'advice.kicker': '표현력 점검',
  'advice.perBead': '비즈 1개당 원본 픽셀 수',
  'advice.text': '현재 칸 수로는 이 복잡한 이미지의 모든 디테일을 담기 어렵습니다.',
  'advice.title': '이미지를 주요 영역 중심으로 잘라주세요',
  'app.heading': 'Bead Grid Studio: 펄러비즈 도안 생성기',
  'app.skipCanvas': '도안 캔버스로 건너뛰기',
  'aria.boardLayout': '비즈판 배열',
  'aria.chooseColor': '{code} {name} 선택',
  'aria.closeControls': '설정 닫기',
  'aria.closeCrop': '자르기 창 닫기',
  'aria.closeMaking': '제작 도우미 닫기',
  'aria.closePalette': '팔레트 닫기',
  'aria.closeProduct': '제품 정보 닫기',
  'aria.closeShare': '공유 창 닫기',
  'aria.codesOff': '칸별 색상 번호 숨기기',
  'aria.codesOn': '칸별 색상 번호 표시',
  'aria.codesZoom': '색상 번호 켜짐; 확대하여 확인하세요',
  'aria.communityActions': '오픈소스 커뮤니티 작업',
  'aria.controls': '도안 설정',
  'aria.copyStats': '비즈 주문을 위해 모든 색상 코드와 수량을 텍스트로 복사',
  'aria.cropPreview': '자르기 미리보기',
  'aria.focusColor': '{code} 강조, 남은 수량 {count}개',
  'aria.help': '도움말, 개인정보 및 버전 정보',
  'aria.localPromises': '로컬 및 오프라인 기능 약속',
  'aria.makingActions': '제작 도우미 제어',
  'aria.makingProgress': '비즈 제작 진행률',
  'aria.markColorDone': '{code} 완료 처리',
  'aria.markColorUndone': '{code} 미완료 처리',
  'aria.mobilePanels': '모바일 패널',
  'aria.nextColor': '다음 색상',
  'aria.paletteRange': '팔레트 규격',
  'aria.paletteSeries': '색상 계열 필터',
  'aria.paletteStats': '팔레트 및 재료 통계',
  'aria.patternCanvas': '{cols} × {rows} 펄러비즈 도안. 방향키로 이동, Space로 그리기, Delete로 지우기.',
  'aria.presets': '가장 긴 변 프리셋',
  'aria.preview': '미리보기 형태',
  'aria.previousColor': '이전 색상',
  'aria.printImage': '인쇄용으로 준비된 펄러비즈 도안',
  'aria.printSheet': '인쇄용 도안',
  'aria.projectLicense': '프로젝트 및 라이선스',
  'aria.readyActions': '도안 준비 완료 동작',
  'aria.redo': '다시 실행',
  'aria.searchPalette': '팔레트 검색',
  'aria.sharePreview': '공유 카드 미리보기',
  'aria.sizeMode': '크기 지정 모드',
  'aria.stage': '도안 미리보기 및 편집기',
  'aria.statShare': '전체 비즈의 {percent}',
  'aria.steps': '이용 단계',
  'aria.tools': '그리기 도구',
  'aria.undo': '실행 취소',
  'aria.viewOptions': '보기 옵션',
  'aria.zoom': '캔버스 확대/축소',
  'aria.zoomIn': '확대',
  'aria.zoomOut': '축소',
  'board.artkal50': 'Artkal 미니 2.6mm · 판당 50×50칸',
  'board.artkal78': 'Artkal 미니 2.6mm · 판당 78×78칸',
  'board.compatibilityNote': '50칸 판과 52칸 판은 핀 간격이 다를 수 있습니다. 소지하신 실물 판 규격에 맞게 선택하세요.',
  'board.initialText': '이미지를 업로드하면 실제 도안 차지 칸 수, 여백, 필요한 판 수, 완성 치수가 표시됩니다.',
  'board.initialTitle': '52×52 비즈판 · 도안은 원본 비율 유지',
  'board.layout.1x1': '1×1판',
  'board.layout.1x2': '세로 2판',
  'board.layout.2x1': '가로 2판',
  'board.layout.2x2': '2×2판',
  'board.layout.2x3': '2×3판',
  'board.layout.3x2': '3×2판',
  'board.midi14': '소형 5mm · 판당 14×14칸',
  'board.midi29': '표준 5mm · 판당 29×29칸',
  'board.mini26': '소형 미니 2.6mm · 판당 26×26칸',
  'board.mini52': '일반 미니 2.6mm · 판당 52×52칸',
  'board.profile': '실물 비즈판 규격',
  'board.statusBody': '{profile} × {count}판; 약 {width}×{height}cm. 중앙 배치: 좌우 여백 {left}/{right}칸, 상하 여백 {top}/{bottom}칸, 총 {blank}개 빈 공간.',
  'board.statusTitle': '비즈판 {boardCols}×{boardRows} · 도안 {patternCols}×{patternRows} (비율 유지)',
  'brand.aria': 'Bead Grid Studio',
  'brand.name': 'Bead Grid Studio',
  'brand.tagline': '펄러비즈 도안 생성기',
  'canvas.help': '방향키로 커서 이동, 스페이스바로 그리기, Delete키로 현재 칸을 지웁니다.',
  'confirm.boardQualityLow': '\n\n선명도 안내: 단일 판은 단순한 캐릭터에 적합합니다. 복잡한 사진은 104칸 이상 레이아웃을 권장합니다.',
  'confirm.boardQualitySevere': '\n\n선명도 경고: 이 비즈판은 주요 윤곽선과 큰 색면만 표현할 수 있습니다. 텍스트와 섬세한 묘사는 알아볼 수 없습니다.',
  'confirm.boardSwitch': '{profile}, {tilesX}×{tilesY}판 구성으로 전환하고 “도안 {patternCols}×{patternRows} / 비즈판 {boardCols}×{boardRows}”를 생성하시겠습니까? 수동 편집 내용은 대체되지만 완료 후 취소할 수 있습니다.{quality}\n\n계속하시겠습니까?',
  'confirm.clear': '현재 도안을 지우시겠습니까? 이 작업은 취소할 수 있습니다.',
  'confirm.clearDraft': '브라우저에 임시 저장된 복구 기록만 지우며, 이미 다운로드한 파일은 삭제되지 않습니다. 지우시겠습니까?',
  'confirm.coverCrop': '캔버스를 채우면 원본의 약 {percent}%가 잘려나갑니다. 피사체가 가장자리에 닿지 않았는지 확인하세요. 잘라서 채우시겠습니까?',
  'confirm.exportIssues': '이 도안에는 {issues} 문제가 있습니다. 크기를 키우거나 브러시로 수정한 후 내보내는 것을 권장합니다. 그래도 내보내시겠습니까?',
  'confirm.loadProject': '현재 도안에 저장되지 않은 변경 사항이 있습니다. 다른 프로젝트를 열면 덮어씁니다. 저장하려면 [취소]를 누르세요.\n\n변경 사항을 무시하고 계속하시겠습니까?',
  'confirm.patternMode': '도안 선명도 모드로 전환하고 비즈판에서 {cols}×{rows} 도안을 추출해 재생성하시겠습니까? 수동 수정 사항이 대체되지만 취소할 수 있습니다. 계속하시겠습니까?',
  'confirm.printPages': '이 {cols}×{rows} 도안은 페이지당 최대 {span}×{span}칸({pages}페이지)으로 분할 인쇄됩니다. 각 페이지에 전체 좌표, 색상 번호, 보조선, 재료 수가 포함됩니다. 계속하시겠습니까?',
  'confirm.replaceImage': '현재 도안에 저장되지 않은 변경 사항이 있습니다. 다른 이미지를 선택하면 덮어씁니다. 저장하려면 [취소]를 누르세요.\n\n변경 사항을 무시하고 계속하시겠습니까?',
  'confirm.resetMaking': '색상별 제작 진행 상황을 모두 초기화하시겠습니까? 도안 자체는 변경되지 않습니다.',
  'confirm.resize': '{cols}×{rows} 크기로 변경하고 원본에서 재생성하시겠습니까? 수동 수정 내용이 대체되지만 취소(Undo)로 복원할 수 있습니다.{quality}\n\n계속하시겠습니까?',
  'confirm.resizeQuality': '\n\n선명도 경고: 유효한 칸이 약 {cells}칸에 불과합니다. 주요 윤곽만 남고 텍스트와 디테일은 사라집니다.',
  'conversion.analyzing': '이미지 및 팔레트 분석 중…',
  'conversion.backgroundRemoved': ', 연결된 배경 여백화 완료',
  'conversion.colorsMerged': ', {before}색에서 {after}색으로 병합 정리됨',
  'conversion.progress': '{mode} 모드로 처리 중 · 최대 {colors}색…',
  'conversion.title': '펄러비즈 도안 생성 중',
  'crop.height': '영역 세로 %',
  'crop.help': '이미지 위에서 드래그하여 사각형을 그리거나 아래에서 비율을 입력하세요. 주요 대상에 집중해 자를수록 비즈 하나하나의 디테일이 살아납니다.',
  'crop.left': '왼쪽 여백 %',
  'crop.precise': '정밀 자르기 (원본 이미지 대비 %)',
  'crop.sourcePixels': '{width} × {height} 원본 픽셀',
  'crop.title': '제작할 영역 자르기',
  'crop.top': '위쪽 여백 %',
  'crop.width': '영역 가로 %',
  'csv.code': '색상 번호',
  'csv.completed': '제작 완료',
  'csv.count': '수량',
  'csv.hex': '화면 참고 HEX',
  'csv.name': '색상 이름',
  'csv.no': '미완료',
  'csv.yes': '완료',
  'draft.clear': '복구 데이터 삭제',
  'draft.restore': '미완성 도안 복원',
  'dropzone.note': '이미지 유형을 자동 감지하고 흑백을 보정하며 비율을 유지합니다. 제작 전 실물 비즈판과 색상표를 확인하세요.',
  'dropzone.title': '이미지 선택 · 스마트 비즈 도안 생성',
  'export.boardCopy': '{profile} × {tilesX}×{tilesY}판 · 도안 {cols}×{rows}',
  'export.boardSize': '도안 {patternCols}×{patternRows} · 비즈판 {boardCols}×{boardRows} · {boards}판',
  'export.count': '{count}개',
  'export.generated': 'Bead Grid Studio v{version} · 로컬 생성',
  'export.header': '{title} · {cols}열 × {rows}행 · {colors}색 · 총 {beads}개',
  'export.materials': '재료 목록',
  'export.patternCopy': '원본 비율을 반영한 도안 규격',
  'export.patternSize': '{cols} 열 × {rows} 행',
  'export.sizeSummary': '도안 크기: {size} · 보조선 {step}칸마다',
  'export.subtitle': 'MARD 호환 기본 221 색상 · {board} · 보조선 {step}칸마다 · 칸별 색상 번호',
  'export.total': '필요한 총 비즈 수: {count}개',
  'field.fitMode': '맞춤 방식',
  'field.lightBackground': '밝은 배경',
  'field.maxColors': '도안당 최대 색상 수',
  'field.maxColorsNote': '자동 매칭은 현재 팔레트에서 가장 가까운 색을 선택합니다. 이 설정은 본 도안에서 실제로 사용할 색상 수를 제한하며, 팔레트 전체 색상 수와는 다릅니다.',
  'field.mergeNote': '값이 높을수록 비슷한 색상이 정리되어 도안이 깔끔해집니다. 짙은 윤곽선과 고채도 포인트는 우선 보존됩니다.',
  'field.mergeStrength': '유사 색상 병합',
  'field.processMode': '변환 모드',
  'field.protectDark': '순수 블랙 보호',
  'field.protectDarkNote': '압축 손실이나 반사광으로 인해 어두운 검정이 짙은 파랑, 갈색, 보라색으로 잘못 매칭되는 것을 방지합니다.',
  'field.referenceOpacity': '원본 대조 투명도',
  'file.cropped': '자르기 · {width}×{height} 원본 픽셀',
  'file.details': '{width} × {height} · {size} MB{suffix}',
  'file.patternFallback': 'bead-pattern',
  'file.restored': '원본 전체 영역 복원 완료',
  'file.trimmed': ' · 주요 영역 자동 프레이밍',
  'fit.contain': '전체 이미지 표시',
  'fit.cover': '채우고 자르기',
  'footer.license': '오픈소스 라이선스',
  'footer.notices': '제3자 공지',
  'footer.privacy': '개인정보 보호',
  'footer.terms': '이용약관',
  'hero.flow1': '이미지 넣기',
  'hero.flow2': '도안 생성',
  'hero.flow3': '색상 매칭',
  'hero.flow4': '비즈 수량 집계',
  'hero.flow5': '도안 내보내기',
  'hero.local': '브라우저에서 100% 로컬 처리',
  'hero.noAccount': '가입 불필요',
  'hero.noInstall': '설치 불필요',
  'hero.noUpload': '이미지 서버 업로드 없음',
  'hero.offline': '오프라인 지원',
  'hero.text': '이미지를 드래그하여 색상 매칭, 비즈 수량 집계, 인쇄용 도안 출력을 한 번에 완료하세요.',
  'hero.title': '이미지 → 펄러비즈 도안',
  'history.boardChanged': '실물 비즈판 규격 변경 완료',
  'history.cleared': '도안 전체 삭제 완료',
  'history.converted': '이미지 변환 완료',
  'history.edited': '도안 편집 완료',
  'history.keyboardDraw': '키보드로 그리기 완료',
  'history.keyboardErase': '키보드로 지우기 완료',
  'history.mirroredH': '좌우 반전 완료',
  'history.mirroredV': '상하 반전 완료',
  'history.rotated': '시계 방향으로 90° 회전 완료',
  'history.sizeCleared': '도안 크기 변경 및 캔버스 초기화 완료',
  'history.stroke': '그리기 스트로크 완료',
  'history.undoAvailable': '{label} · {count}단계 실행 취소 가능',
  'language.chinese': '中文',
  'language.english': 'EN',
  'language.french': 'FR',
  'language.japanese': 'JA',
  'language.korean': '한국어',
  'language.label': '인터페이스 언어',
  'legend.codesZoom': '확대하여 색상 번호 확인',
  'legend.empty': '변환 후 색상 번호와 수량이 표시됩니다',
  'legend.title': '도안 범례',
  'making.allColors': '전체 색상 표시 중',
  'making.allColorsDetail': '재료 목록의 항목을 클릭하면 해당 색상을 다시 강조합니다',
  'making.allDone': '모든 색상 배치 완료',
  'making.allDoneDetail': '제작 도안과 비교하여 최종 검수를 진행하세요',
  'making.chooseColor': '재료 목록에서 색상을 선택하세요',
  'making.focusedCount': '이 색상에서 추가 확인 필요: {count}개',
  'making.kicker': '제작 도우미',
  'making.progress': '{done}/{total}개 · {colorsDone}/{totalColors}색 · {percent}%',
  'making.progressAria': '{percent}% 완료, {totalColors}개 색상 중 {colorsDone}개 완료',
  'making.title': '색상별 순서대로 비즈 놓기',
  'meta.description': '이미지를 색상 번호, 격자 보조선, 재료 수량이 포함된 인쇄 가능한 펄러비즈 도안으로 변환합니다. 모든 처리는 브라우저에서 로컬로 진행됩니다.',
  'meta.ogDescription': '색상 매칭, 비즈 수량 계산, 그리드 편집 및 인쇄용 도안 내보내기까지 모두 로컬에서 처리됩니다.',
  'meta.ogLocale': 'ko_KR',
  'meta.ogTitle': 'Bead Grid Studio · 이미지 펄러비즈 도안 생성기',
  'meta.schemaDescription': '브라우저에서 이미지를 편집 및 인쇄 가능한 비즈 도안으로 변환하는 로컬 우선 도안 생성기입니다.',
  'meta.schemaName': 'Bead Grid Studio',
  'meta.title': 'Bead Grid Studio — 이미지 펄러비즈 도안 생성기',
  'mobile.palette': '팔레트',
  'mobile.pattern': '도안',
  'mobile.stats': '수량',
  'mobile.tools': '도구',
  'mode.cartoon': '아이콘 및 라인 아트 · 윤곽선 보존',
  'mode.detail': '상세 사진 · 명암 디테일 유지',
  'mode.document': '문서 구조 · 레이아웃 보존',
  'mode.photo': '자연스러운 사진 · 영역 평균',
  'mode.pixel': '픽셀 아트 샘플링 · 보정 없음',
  'modeHint.cartoon': '캐릭터, 라인 아트, 로고에 적합. 검은 외곽선과 채도 높은 세부 포인트를 유지합니다.',
  'modeHint.detail': '인물, 반려동물, 복잡한 사진에 적합. 어두운 형태를 보호하면서 국소 대비를 강화합니다.',
  'modeHint.document': '문서, 캡처 화면, 도표에 적합. 작은 글자는 단순화하고 긴 선과 넓은 채우기를 유지합니다 (본문 글자는 읽을 수 없습니다).',
  'modeHint.photo': '일반 사진, 그라데이션, 부드러운 조명에 적합. 선형 조명 공간에서 각 칸을 평균화합니다.',
  'modeHint.pixel': '이미 픽셀 아트인 이미지에 적합. 보정 없이 각 칸의 정중앙 픽셀을 읽어옵니다.',
  'output.major10': '10칸마다 (권장)',
  'output.major29': '29칸마다 (일반적인 5mm 사각 판)',
  'output.major5': '5칸마다',
  'output.majorGrid': '굵은 보조선 간격',
  'output.majorNote': '화면 미리보기와 최종 제작용 도안에 동일하게 표시되며, 빠른 위치 확인과 판 조립에 유용합니다.',
  'output.subtitle': 'PNG / JSON / 인쇄',
  'output.title': '프로젝트 및 출력',
  'palette.all': '전체',
  'palette.black': '검정',
  'palette.countAll': '221색 · 9개 계열',
  'palette.countSeries': '{series} 계열 · {count}색',
  'palette.note': '현재 MARD 호환 기본 221 색상(A/B/C/D/E/F/G/H/M)을 제공합니다. H1은 투명색으로 수동 그리기 전용입니다. 자동 변환은 220개의 실색을 사용하며 흰색은 H2, 검정은 H7로 고정됩니다. 화면 HEX는 참고용이며 실물 비즈 색상표를 확인하세요.',
  'palette.panel': '팔레트 및 재료',
  'palette.provider': 'MARD 호환 기본 221색',
  'palette.search': '색상 번호 또는 이름 검색',
  'palette.series.A': '옐로우·오렌지 계열',
  'palette.series.B': '그린 계열',
  'palette.series.C': '블루·시안 계열',
  'palette.series.D': '블루·퍼플 계열',
  'palette.series.E': '핑크·로즈 계열',
  'palette.series.F': '레드 계열',
  'palette.series.G': '브라운·스킨톤 계열',
  'palette.series.H': '모노톤 계열',
  'palette.series.M': '어스 계열',
  'palette.title': '팔레트',
  'palette.transparent': '투명',
  'palette.white': '흰색',
  'panel.image': '이미지 및 변환',
  'panel.localProcessing': '로컬 처리',
  'panel.tools': '도구 및 설정',
  'preview.bead': '비즈 미리보기',
  'preview.square': '색상 블록',
  'print.count': '{code} · {count}개',
  'print.materials': '이 페이지 사용 재료',
  'print.pageSubtitle': '전체 도안 {cols}×{rows} · 이 페이지 가로 {startCol}–{endCol} / 세로 {startRow}–{endRow} · 호환 221 색상 번호',
  'print.pageTitle': '{title} · {page}/{pages} 페이지',
  'product.colorText': '현재 팔레트는 MARD 호환 기본 221색 데이터를 사용합니다. 관련 브랜드와는 공식 제휴 관계가 없으며 화면 색상은 참고용입니다.',
  'product.colorTitle': '색상 및 상표 안내',
  'product.intro': 'Bead Grid Studio는 브라우저 로컬에서 작동하는 오픈소스 비즈 도안 도구입니다. 계정 가입, 결제, 라이선스 키, 클라우드 변환이 전혀 없습니다.',
  'product.performanceText': '50칸과 52칸 비즈판은 호환되지 않을 수 있습니다. 대형 도안에서는 메모리 보호를 위해 최대 줌 비율이 제한됩니다.',
  'product.performanceTitle': '비즈판 및 성능',
  'product.privacy': '개인정보 보호',
  'product.privacyText': '원본 이미지는 서버로 전송되지 않습니다. 미완성 도안 데이터는 원본 이미지 없이 브라우저에 임시 저장되며 언제든 삭제할 수 있습니다.',
  'product.privacyTitle': '개인정보 보호 및 복구',
  'product.repo': '오픈소스 저장소',
  'product.step1': '이미지를 선택하고 필요한 경우 대상을 중심으로 자릅니다.',
  'product.step2': '비율, 사용할 비즈판, 색상 수, 비즈 수량을 확인하고 조절합니다.',
  'product.step3': '색상 번호가 표시된 도안을 출력합니다. 대형 도안은 분할 인쇄를 활용하세요.',
  'product.stepsTitle': '간단한 3단계 제작 과정',
  'product.terms': '이용약관',
  'product.title': '도움말, 개인정보 및 버전 정보',
  'product.version': '버전',
  'project.defaultName': 'bead-pattern-project',
  'project.fileDescription': 'Bead Grid Studio 편집 가능 프로젝트',
  'project.imageLocal': '{width} × {height} · 로컬 처리 완료',
  'project.importedName': '가져온 도안',
  'project.loadedSubtitle': 'JSON 프로젝트 로드 완료 · 원본 이미지는 미포함',
  'project.localOnly': '이미지는 현재 브라우저 내에서만 처리됩니다',
  'project.recoveryFile': 'recovery.bead.json',
  'project.untitled': '제목 없는 도안',
  'prompt.projectName': '프로젝트 이름은 JSON에 저장됩니다. 원본 파일명에 개인정보나 주문 번호가 있다면 여기서 변경하세요.',
  'punctuation.list': ', ',
  'quality.alreadySize': '이미 {cols}×{rows} 크기입니다',
  'quality.aspectMismatch': '도안 종횡비 불일치',
  'quality.aspectShort': '{cols}×{rows} 크기는 원본 비율과 일치하지 않습니다; {result}',
  'quality.aspectTitle': '{cols}×{rows} 규격이 원본 비율과 일치하지 않습니다',
  'quality.aspectWarning': '종횡비 및 자르기 경고',
  'quality.cellConflict': '칸 충돌',
  'quality.crop': '주요 대상 자르기',
  'quality.cropBody': '캔버스를 채우면 원본의 약 {percent}%가 잘려나갑니다. 가장자리 피사체가 잘릴 수 있습니다.',
  'quality.cropChoose': '자르고 대상 선택',
  'quality.cropPercent': '잘림 {percent}%',
  'quality.cropSubject': '피사체 자르기',
  'quality.cropSuggestion': '먼저 좁은 영역으로 자르는 것을 권장합니다',
  'quality.cropVerb': '자르기',
  'quality.cropsContent': '원본 이미지의 일부가 잘립니다',
  'quality.detailBody': '{warning}. 다음 크기로 확대하거나 브러시로 직접 보정하세요.',
  'quality.detailCollisions': '{count}개의 디테일 충돌을 안전하게 분리할 수 없습니다',
  'quality.detailConflict': '일부 디테일이 현재 격자 크기를 초과합니다',
  'quality.detailIntegrity': '{details}; 임의의 가짜 비즈를 넣거나 선을 뭉개지 않았습니다',
  'quality.detailShort': '{size}: {warning}; 임의의 비즈가 추가되지 않았습니다',
  'quality.documentBody': '{size}에서는 레이아웃과 큰 색면만 남고 본문 텍스트는 식별되지 않습니다. {modeAdvice}비즈 알당 {beadMm}mm 기준 완성 크기는 약 {width}×{height}cm입니다.',
  'quality.documentModeAdvice': '아래에서 문서 구조 모드로 전환하는 것을 권장합니다. ',
  'quality.documentTitle': '전체 문서는 가독 가능한 칸 수 범위를 초과합니다',
  'quality.documentWarning': '문서 표현력 경고',
  'quality.fixAspect': '비율을 {cols}×{rows}로 맞추기',
  'quality.fixAspectShort': '종횡비 맞추기',
  'quality.glyphHeight': '본문 높이는 약 {height}칸 수준입니다',
  'quality.hasMargins': '넓은 여백이 발생합니다',
  'quality.increaseSize': '{cols}×{rows}로 확대 · {beadMm}mm 기준 약 {width}×{height}cm',
  'quality.largeStructureOnly': '큰 구조만 표현 가능',
  'quality.letterboxBody': '이미지가 왜곡되지는 않으나 도안의 약 {percent}%가 여백입니다. 약 {cols}×{rows}칸에만 이미지가 들어갑니다. 원본 비율을 권장합니다.',
  'quality.marginPercent': '여백 {percent}%',
  'quality.marginVerb': '여백 남기기',
  'quality.missingDetails': '{count}개의 디테일이 한 칸보다 작습니다',
  'quality.modeOrCropSuggestion': '문서 구조 모드로 바꾸거나 먼저 잘라내세요',
  'quality.oneSubject': '단일 대상만 제작',
  'quality.outlineOnly': '이 크기에서는 윤곽선만 표현 가능합니다',
  'quality.outlineShort': '{size} 크기에서는 주요 윤곽선과 큰 색면만 유지됩니다.',
  'quality.photoBody': '유효한 가장 긴 변은 약 {long}칸(유효 {cells}칸)입니다. 작은 글자와 경계가 사라집니다.',
  'quality.photoDetailTitle': '현재 격자로는 사진의 모든 디테일을 담을 수 없습니다',
  'quality.pixelsPerBead': '1칸당 약 {count}픽셀',
  'quality.smallWarning': '작은 도안 디테일 경고',
  'quality.sourcePixels': '{x}×{y} 원본 픽셀',
  'quality.structureOnlyShort': '{size} 크기에서는 큰 레이아웃만 유지됩니다; {action}',
  'quality.text': '본문 텍스트와 얇은 선은 선명하게 표현되지 않습니다',
  'quality.textTooSmall': '텍스트가 제작 가능한 크기보다 작습니다',
  'quality.title': '이 이미지는 현재 격자 용량을 초과합니다',
  'ready.kicker': '도안 완성 🎉',
  'ready.text': '내보내거나 공유하기 전에 도안, 색상 번호, 비즈 수량을 확인하세요.',
  'share.cardFooter': 'github.com/zwhy149/bead-grid-studio',
  'share.cardSubtitle': '로컬 처리 • 편집 가능 • 인쇄 지원 • 오픈소스',
  'share.cardTitle': '이미지 → 펄러비즈 도안',
  'share.copied': '링크가 복사되었습니다',
  'share.dialogHelp': '공유 카드는 직접 요청할 때만 생성되며, 공식 제작 도안을 수정하거나 원본 이미지를 업로드하지 않습니다.',
  'share.dialogTitle': '공유 카드 내보내기',
  'share.download': '공유 카드 다운로드',
  'share.failed': '공유 기능을 사용할 수 없어 링크를 대신 복사했습니다.',
  'share.formatLabel': '공유 카드 비율',
  'share.original': '원본 이미지',
  'share.pattern': '비즈 도안',
  'share.portrait': '3:4 · 모바일 / SNS 게시용',
  'share.text': 'Bead Grid Studio로 펄러비즈 도안을 만들었습니다 🫘',
  'share.title': 'Bead Grid Studio로 만든 펄러비즈 도안',
  'share.unavailable': '이 프로젝트는 원본 이미지를 포함하지 않아 전후 비교 공유 카드를 생성할 수 없습니다.',
  'share.wide': '16:9 · X / Reddit / Discord용',
  'size.aspectInitial': '이미지 선택 후 프리셋은 정사각형 강제 변형이 아닌 도안의 가장 긴 변을 기준으로 적용됩니다.',
  'size.aspectLocked': '원본 이미지 비율 {ratio}:1로 고정됨. 프리셋 선택 시 {cols}×{rows}처럼 등비로 적용됩니다.',
  'size.aspectUnlocked': '비율 고정이 해제되었습니다. 전체 표시는 여백을 추가하고, 채우기는 초과 영역을 자릅니다.',
  'size.aspectUnlockedInitial': '비율 잠금 해제됨. 이미지 선택 후 가로세로를 개별 지정할 수 있습니다.',
  'size.boardCols': '비즈판 총 가로 칸 수',
  'size.boardMode': '실물 비즈판 기준',
  'size.boardRows': '비즈판 총 세로 칸 수',
  'size.lockAspect': '원본 비율 고정 (권장)',
  'size.longSide': ({ size }) => `긴 쪽 ${size}`,
  'size.patternAndBoard': '도안 {patternCols}×{patternRows} / 판 {boardCols}×{boardRows}',
  'size.patternHeight': '도안 세로 칸 수',
  'size.patternMode': '도안 디테일 기준',
  'size.patternOnly': '도안 {cols}×{rows}',
  'size.patternWidth': '도안 가로 칸 수',
  'size.subtitle': '도안과 비즈판은 개별 설정 가능',
  'size.title': '도안 크기',
  'smart.calculating': '추천 구성을 계산하는 중',
  'smart.cropFirst': '제작할 영역 먼저 자르기',
  'smart.custom': '사용자 지정 설정 사용 중',
  'smart.customAspect': '사용자 지정 크기가 원본 비율과 맞지 않습니다',
  'smart.customCapacity': '현재 {cols}×{rows}의 유효 칸 수는 약 {cells}칸입니다. 크기를 키우거나 대상을 잘라내세요.',
  'smart.customIssues': '현재 {cols}×{rows}: {warning}. 다음 크기로 키우거나 브러시로 보정하세요.',
  'smart.customMismatch': '이로 인해 약 {percent}%의 {effect}이(가) 발생합니다. 아래 [종횡비 맞추기]를 이용하세요.',
  'smart.customSummary': '현재 {cols}×{rows}, 최대 {colors}색. 언제든 자동 추천으로 되돌릴 수 있습니다.',
  'smart.customTooSmall': '사용자 지정 크기가 너무 작아 주요 윤곽선만 유지됩니다',
  'smart.defaultSummary': '크기, 변환 모드, 팔레트 및 미리보기 방식을 자동으로 선택합니다.',
  'smart.detailWarning': '{warning}. {size}칸으로 키우거나 브러시로 보정하세요.',
  'smart.documentSummary': '최대 {cols}×{rows} 크기에서 레이아웃과 큰 색면만 유지됩니다. 제작할 영역 하나를 잘라내세요.',
  'smart.documentUnreadable': '글자가 많은 전체 문서는 비즈 도안으로 글자를 읽을 수 없습니다',
  'smart.generate': '자동 생성하기',
  'smart.generatedReview': '도안 생성 완료 — 내보내기 전 확인하세요',
  'smart.generatedSmallLine': '작은 도안 라인 아트 최적화 완료',
  'smart.generatedWithWarning': '생성되었으나 {warning}',
  'smart.kicker': '원클릭 스마트 모드',
  'smart.readySummary': '{size} · {beads}개 비즈 · {colors}색 · 원본 비율 유지. {framing}{detailWarning}{beadMm}mm 기준 약 {width}×{height}cm. 실물 색상표와 대조 후 제작하세요.',
  'smart.recommendedReady': '추천 구성 준비 완료',
  'smart.recommendedSummary': '{cols}×{rows} · {capacity}칸 · 최대 {colors}색 · {trimmed}MARD 호환 기본 221색 · 흑백 보정 완료 · 칸별 번호 표기',
  'smart.regenerate': '다시 생성',
  'smart.restore': '자동 추천 설정으로 복원',
  'smart.step1': '1 이미지 추가',
  'smart.step2': '2 도안 검토',
  'smart.step3': '3 제작용 내보내기',
  'smart.trimmed': '외곽 여백의 약 {percent}%를 자동 정리했습니다. 언제든 원본 전체로 복원할 수 있습니다.',
  'smart.trimmedShort': '외곽 여백 약 {percent}% 정리됨 · ',
  'stats.colors': '사용 색상 수',
  'stats.copyList': '구매 목록 복사',
  'stats.empty': '빈 칸',
  'stats.emptyList': '이미지를 추가하거나 캔버스에 그리면 색상별 필요 수량이 여기에 표시됩니다.',
  'stats.listLine': '{code} {name} · {count}개 · {percent}',
  'stats.listMeta': '도안: {cols} × {rows} 칸 · 총 {total}개 · {colors}가지 색상',
  'stats.listTip': '제조사 및 생산 배치에 따라 색상 차이가 있을 수 있으니 구매 전 실물 색상표를 확인하고 약 10%의 여유분을 권장합니다.',
  'stats.listTitle': '펄러비즈 구매 목록 (Bead Grid Studio 생성)',
  'stats.sorted': '수량순 정렬',
  'stats.title': '비즈 재료 통계',
  'stats.total': '총 비즈 수',
  'status.boardPattern': '도안 {patternCols}×{patternRows} / 판 {boardCols}×{boardRows}',
  'status.boardSwitched': '실물 비즈판 규격 변경 완료',
  'status.browserUnsupported': '이 브라우저는 안전한 백그라운드 변환을 지원하지 않습니다',
  'status.canvasFit': '창 크기에 맞춤 완료',
  'status.canvasOverview': '전체 보기 · 편집하려면 확대하세요',
  'status.cleared': '도안 초기화 완료',
  'status.complexPreview': '복잡한 문서 미리보기',
  'status.conversionBlocked': '변환 처리 중 · 도안 상태를 변경하는 작업이 차단되었습니다',
  'status.conversionCanceled': '변환이 취소되고 이전 완성 도안이 복원되었습니다',
  'status.conversionComplete': '변환 완료 · {mode} · {size} · {colors}색',
  'status.conversionFailed': '{reason} · 이전 완성 도안을 복원했습니다',
  'status.cropSuggested': '한 영역을 먼저 잘라내세요',
  'status.csvExported': '재료 CSV 내보내기 완료 · {colors}색 · {beads}개 비즈',
  'status.documentPreview': '{kind} · 본문 텍스트 식별 불가 · {size} · {advice}',
  'status.draftCleared': '로컬 복구 기록 삭제 완료',
  'status.exportDone': '제작 도안 PNG 내보내기 완료',
  'status.exportFailed': 'PNG 내보내기 실패',
  'status.exporting': '고해상도 PNG 생성 중…',
  'status.failed': '변환 실패',
  'status.generatingPixel': '{cols}×{rows} 픽셀 정밀 도안 생성 중…',
  'status.imageReadFailed': '이미지를 읽을 수 없습니다',
  'status.loadingSample': '내장 샘플 로딩 중…',
  'status.majorGrid': '굵은 보조선 간격을 {count}칸으로 설정했습니다',
  'status.makingStarted': '제작 도우미 활성화 · 색상별 순차 제작 및 검수 가능',
  'status.makingStopped': '제작 도우미 종료 · 진행 상황은 프로젝트에 유지됩니다',
  'status.mirroredH': '좌우 반전 완료',
  'status.mirroredV': '상하 반전 완료',
  'status.modeSuggested': '문서 구조 모드로 전환하거나 먼저 자르세요',
  'status.printFailed': '인쇄 미리보기 실패',
  'status.printReady': '{count}페이지 인쇄 준비 완료 · 인쇄 설정의 용지 맞춤 중복 확대를 해제하세요',
  'status.projectDownloadStarted': '프로젝트 다운로드 시작됨',
  'status.projectLoadFailed': '프로젝트 불러오기 실패',
  'status.projectLoaded': '{cols}×{rows} 프로젝트 로드 완료{migration}',
  'status.projectMigration': ' · 호환 기본 221 색상으로 변환됨',
  'status.projectRestored': '미완성 {cols}×{rows} 프로젝트 복원 완료',
  'status.projectSaved': '프로젝트 파일 저장 완료',
  'status.readingImage': '이미지 읽는 중…',
  'status.ready': '준비 완료 · 모든 처리는 브라우저 내부에서 진행됩니다',
  'status.redo': '작업을 다시 실행했습니다',
  'status.rotated': '시계 방향으로 90° 회전 완료',
  'status.sampleFailed': '샘플 로딩 실패',
  'status.sizeCleared': '도안 크기 변경 및 캔버스 초기화 완료',
  'status.smallRefine': '작은 도안 최적화 완료 · {warning} · 더 세밀한 표현은 칸 수를 늘리세요',
  'status.structurePreview': '문서 구조 미리보기',
  'status.timeout': '변환 시간 초과',
  'status.undo': '이전 작업을 실행 취소했습니다',
  'status.zoom': '{message} · 확대 {percent}%',
  'status.zoomValue': '확대 {percent}%',
  'title.codesToggle': '칸별 색상 번호 표시/숨기기',
  'title.codesZoom': '색상 번호가 켜져 있습니다. 각 칸이 14픽셀 이상이 되도록 확대하세요',
  'title.color': '{code} {name} {hex}',
  'title.fitCanvas': '전체 도안을 창에 맞추기',
  'title.redo': '다시 실행 Ctrl+Y',
  'title.toggleCodes': '칸별 색상 번호 표시/숨기기',
  'title.toggleGrid': '그리드 표시/숨기기',
  'title.toggleRuler': '좌표 눈금자 표시/숨기기',
  'title.undo': '실행 취소 Ctrl+Z',
  'title.zoomLimit': '이 도안의 최대 확대 비율: {percent}%',
  'toast.boardContainOnly': '실물 비즈판 모드는 항상 비율을 유지하며 왜곡이나 임의 잘림 없이 중앙 배치됩니다.',
  'toast.boardTooLarge': '비즈판 배열이 160칸 제한을 초과합니다. 판 수를 줄여주세요.',
  'toast.canvasFit': '{percent}% 비율로 맞춤 조정됨',
  'toast.canvasOverview': '전체 도안을 보고 있습니다. 칸을 편집하려면 확대하세요.',
  'toast.chooseImageFirst': '먼저 이미지를 선택하세요.',
  'toast.codesNeedZoom': '현재 전체 보기 상태입니다. 색상 번호를 보려면 100%로 확대하세요. 출력 도안에는 항상 번호가 표기됩니다.',
  'toast.colorDone': '{code} 완료됨. 다음 색상으로 이동합니다.',
  'toast.colorSelected': '{code} {name} 선택됨',
  'toast.colorUndone': '{code} 미완료로 변경되었습니다.',
  'toast.conversionBusy': '이미지 변환 중입니다. 완료를 기다리거나 먼저 취소하세요.',
  'toast.conversionCanceled': '변환이 취소되고 이전 도안이 유지되었습니다.',
  'toast.conversionComplete': '변환 완료: {colors}색{background}{merged}',
  'toast.conversionFailed': '변환에 실패하여 이전 도안을 복원했습니다.',
  'toast.conversionTimeout': '변환 시간이 너무 오래 걸려 취소하고 이전 도안을 복원했습니다. 상세 사진 모드를 사용하거나 이미지 크기를 줄이세요.',
  'toast.cropTooSmall': '자른 영역이 너무 작습니다. 더 넓은 영역을 선택하세요.',
  'toast.csvExported': '재료 목록 내보내기 완료: {colors}색, {beads}개 비즈.',
  'toast.documentDetected': '복잡한 문서를 감지했습니다. 문서 구조 모드로 전환하거나 먼저 자르세요.',
  'toast.documentPreview': '문서 구조 미리보기가 준비되었습니다. 본문 텍스트는 선명하게 유지되지 않습니다.',
  'toast.draftCleared': '로컬 복구 기록을 삭제했습니다.',
  'toast.draftInvalid': '복구 데이터가 손상되어 안전하게 삭제되었습니다.',
  'toast.draftStorage': '브라우저 임시 저장 용량이 가득 찼습니다. 프로젝트 파일을 수동으로 저장하세요.',
  'toast.emptyPicker': '빈 칸에는 색상 번호가 없습니다. 색상이 칠해진 칸을 선택하세요.',
  'toast.exportDone': '색상 번호 포함 제작용 도안이 내보내졌습니다.',
  'toast.exportFailed': '내보내기 실패. 도안 크기를 줄이고 다시 시도하세요.',
  'toast.exportMemory': '기기 메모리 보호를 위해 대형 이미지 단일 생성이 제한됩니다. 크기를 줄이거나 분할 인쇄를 이용하세요.',
  'toast.generatedWarning': '생성되었으나 {warning}. 크기를 늘리거나 브러시로 보정하세요.',
  'toast.imageDamaged': '이미지가 손상되었거나 지원되지 않는 형식입니다.',
  'toast.imagePixelsTooLarge': '이미지 해상도가 너무 높습니다. 크기를 줄이고 다시 시도하세요.',
  'toast.imageTooLarge': '이미지 용량이 24MB를 초과합니다. 압축 후 다시 시도하세요.',
  'toast.invalidImage': '이미지 헤더가 손상되었거나 유효하지 않습니다. 표준 PNG, JPG, WebP, GIF를 사용하세요.',
  'toast.makingReset': '제작 진행 상황이 초기화되었습니다.',
  'toast.makingStarted': '제작 도우미가 켜졌습니다. 캔버스에 현재 색상이 강조됩니다.',
  'toast.noMaterials': '이 도안에는 아직 비즈가 없습니다.',
  'toast.photoModeAuto': '디테일한 사진을 감지하여 오랜 변환을 방지하기 위해 상세 사진 모드로 전환했습니다.',
  'toast.previewEditZoom': '전체 도안 보기 상태입니다. 편집하려면 확대하세요.',
  'toast.printFailed': '인쇄 미리보기 실패. 크기를 줄이거나 PNG로 내보내세요.',
  'toast.projectDownloadStarted': '프로젝트 다운로드가 시작되었습니다. 원본 이미지는 포함되지 않습니다.',
  'toast.projectInvalid': '프로젝트 형식이 올바르지 않거나 지원되지 않는 버전입니다.',
  'toast.projectLoaded': '프로젝트를 불러왔습니다.',
  'toast.projectMigrated': '기존 64색 프로젝트가 호환 기본 221 색상으로 변환되었습니다.',
  'toast.projectRestored': '미완성 프로젝트를 복원했습니다 (원본 이미지 미포함).',
  'toast.projectSaved': '프로젝트 파일이 저장되었습니다 (원본 이미지는 포함되지 않음).',
  'toast.projectTooLarge': '프로젝트 파일이 비어있거나 너무 큽니다.',
  'toast.safeDecodeFailed': '대형 이미지를 안전하게 디코딩하지 못했습니다. 압축 후 다시 시도하세요.',
  'toast.sampleFailed': '내장 샘플을 불러오지 못했습니다. 로컬 이미지를 선택하세요.',
  'toast.statsCopied': '비즈 목록이 복사되었습니다. 메모장이나 주문서에 붙여넣으세요.',
  'toast.statsCopyFailed': '복사 실패. 수량을 직접 메모해 주세요.',
  'toast.workerUnsupported': '안전한 백그라운드 변환을 실행할 수 없습니다. 최신 Chrome, Edge, Firefox, Safari를 사용하세요.',
  'toast.zoomLimit': '메모리 보호를 위해 이 {cols}×{rows} 도안은 최대 줌이 {percent}%로 제한됩니다.',
  'tool.brush': '브러시 B',
  'tool.clear': '도안 지우기',
  'tool.eraser': '지우개 E',
  'tool.mirrorH': '좌우 반전',
  'tool.mirrorV': '상하 반전',
  'tool.picker': '스포이트 I',
  'tool.rotate': '시계 방향으로 90° 회전',
  'tools.subtitle': '드래그하여 연속 그리기 지원',
  'tools.title': '그리기 및 변형',
  'unit.beads': '{formatted} 개',
  'unit.colors': '{count} 색상',
  'unit.colorsValue': '{count} 색상',
  'view.codes': '색상 번호',
  'view.fit': '맞춤',
  'view.grid': '그리드',
  'view.ruler': '눈금자',
  'white.auto': '자동으로 비워두기',
  'white.keep': '흰색 비즈 유지',
};
export default koKR;
